// Vollbild an/aus (Desktop: Taste F oder Menü)
export function toggleFullscreen() {
  try {
    if (document.fullscreenElement) void document.exitFullscreen();
    else void document.documentElement.requestFullscreen?.();
  } catch {
    /* nicht unterstützt */
  }
}
